export default "__VITE_ASSET__b7b71533__"